import React, { FC, useMemo } from 'react';
import { Color, ColorChangeHandler } from 'react-color';
import SketchPicker from 'react-color/lib/components/sketch/Sketch';
import { createPortal } from 'react-dom';
import { colorPickerPortal } from 'src/shared/portals';
import styled from 'styled-components';

const ColorPickerContainer = styled.div<{ x: number; y: number; position: 'fixed' | 'absolute' }>`
    position: ${(props) => props.position};
    left: ${(props) => props.x}px;
    top: ${(props) => props.y}px;
    z-index: 32;
`;

interface ColorPickerProps {
    x: number;
    y: number;
    color: Color;
    position: 'absolute' | 'fixed';
    onChange: ColorChangeHandler;
    onChangeComplete?: ColorChangeHandler;
}

const ColorPicker: FC<ColorPickerProps> = ({ x, y, color, position, onChange, onChangeComplete }) => {
    const content = (
        <ColorPickerContainer x={x} y={y} position={position} onClick={(e) => e.stopPropagation()}>
            <SketchPicker color={color} disableAlpha={true} onChange={onChange} onChangeComplete={onChangeComplete} />
        </ColorPickerContainer>
    );

    if (position === 'fixed') {
        return createPortal(content, colorPickerPortal);
    } else {
        return content;
    }
};

export default ColorPicker;
